import { render, staticRenderFns } from "./publications.vue?vue&type=template&id=945cefd0&scoped=true&"
import script from "./publications.vue?vue&type=script&lang=js&"
export * from "./publications.vue?vue&type=script&lang=js&"
import style0 from "./publications.vue?vue&type=style&index=0&id=945cefd0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945cefd0",
  null
  
)

export default component.exports